export default "__VITE_ASSET__C7lr31F$__"